import readReportCount from "./readReportCount";

const updateAOV = (
  ordersSelector,
  revenueSelector,
  aovSelector,
  options = {}
) => {
  let checkCount = 0;
  const maxChecks = 60; // Stop checking after 30 seconds (60 * 500ms)
  const comparisonExpected = options.comparison_expected === true;

  let aov_check = setInterval(function () {
    // Increment on every tick so the maxChecks safeguard also works when loading never resolves
    checkCount += 1;
    if (checkCount > maxChecks) {
      clearInterval(aov_check);
      return;
    }

    const ordersSpan = $(ordersSelector);
    const revenueSpan = $(revenueSelector);
    const aovElement = $(aovSelector);

    // If required elements are missing, stop checking to avoid an infinite interval
    if (ordersSpan.length === 0 || revenueSpan.length === 0 || aovElement.length === 0) {
      clearInterval(aov_check);
      return;
    }
    // Funnel AOV card has its own React-rendered comparison; never inject our badge there
    const isFunnelAovCard = aovElement.closest("[data-funnel-aov-card]").length > 0;
    const effectiveComparisonExpected = comparisonExpected && !isFunnelAovCard;

    if (ordersSpan.attr("data-loading") == "false" && revenueSpan.attr("data-loading") == "false") {
      const orders = readReportCount(ordersSpan);
      const revenue = readReportCount(revenueSpan);

      let aov = orders && revenue ? revenue / orders : 0;
      $(aovSelector).text(aov.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

      // Handle comparison counts if available
      // Read comparison counts from data attributes set by ReportCount components
      const comparisonOrders = ordersSpan.attr("data-comparison-count");
      const comparisonRevenue = revenueSpan.attr("data-comparison-count");
      
      // Check for existing badge - look for wrapper div on new line
      const parentContainer = aovElement.parent();
      const existingBadge = parentContainer.length > 0 
        ? parentContainer.siblings(".row.hard-center").has(".aov-comparison-badge")
        : aovElement.siblings(".row.hard-center").has(".aov-comparison-badge");

      // Check if comparison payload exists or is expected.
      // Use options.comparison_expected as the source of truth, and also allow
      // existing attributes to indicate presence of comparison data.
      const hasComparisonPayload = comparisonExpected ||
        ordersSpan.is('[data-comparison-count]') ||
        revenueSpan.is('[data-comparison-count]');
      
      // Show placeholder badge immediately if comparison is expected but data not yet loaded
      // This prevents layout shift by reserving space from the start
      const hasComparisonData = comparisonOrders !== undefined && comparisonOrders !== null && comparisonOrders !== "" &&
                                comparisonRevenue !== undefined && comparisonRevenue !== null && comparisonRevenue !== "";
      
      if (effectiveComparisonExpected && hasComparisonPayload && existingBadge.length === 0 && !hasComparisonData) {
        const comparisonLabel = options.comparison_label || "vs last period";
        const hideComparisonLabel = options.hide_comparison_label === true;
        const badgeTitleAttr = hideComparisonLabel ? "" : ` title="${comparisonLabel}"`;
        // No badge exists yet and comparison data isn't ready, show placeholder immediately
        const placeholderBadge = $(`
          <div class="row hard-center">
            <span class="inline-flex items-center px-2 py-1 rounded text-base font-medium aov-comparison-badge aov-comparison-loading bg-gray-100 text-gray-800" style="min-width: 80px;"${badgeTitleAttr}>
              <span class="cf-loading-spinner reports-spinner" style="width: 12px; height: 12px; margin-right: 4px;"></span>
            </span>
          </div>
        `);
        if (options.badgeContainer) {
          $(options.badgeContainer).append(placeholderBadge);
        } else {
          // Append after parent container to place on new line
          if (parentContainer.length > 0) {
            parentContainer.after(placeholderBadge);
          } else {
            aovElement.after(placeholderBadge);
          }
        }
      }

      // If comparison data exists but comparison is not expected or payload doesn't exist, remove badges
      if (hasComparisonData && (!effectiveComparisonExpected || !hasComparisonPayload)) {
        const currentBadge = parentContainer.length > 0 
          ? parentContainer.siblings(".row.hard-center").find(".aov-comparison-badge").parent()
          : aovElement.siblings(".row.hard-center").find(".aov-comparison-badge").parent();
        if (currentBadge.length === 0) {
          // Fallback: try finding badge without parent wrapper
          const fallbackBadge = parentContainer.length > 0 
            ? parentContainer.find(".aov-comparison-badge")
            : aovElement.siblings(".aov-comparison-badge");
          if (fallbackBadge.length > 0) {
            fallbackBadge.remove();
          }
        } else {
          currentBadge.remove();
        }
        clearInterval(aov_check);
      }
      // If we have comparison data, process it (but only if comparison is expected and payload exists)
      else if (hasComparisonData && effectiveComparisonExpected && hasComparisonPayload) {
        clearInterval(aov_check);

        const comparisonOrdersNum = parseInt(comparisonOrders, 10);
        const comparisonRevenueNum = parseFloat(comparisonRevenue);

        // Check if we have valid numbers (not NaN)
        if (!isNaN(comparisonOrdersNum) && !isNaN(comparisonRevenueNum)) {
          let comparisonAOV = 0;
          if (comparisonOrdersNum > 0 && comparisonRevenueNum >= 0) {
            comparisonAOV = comparisonRevenueNum / comparisonOrdersNum;
          }

          // Calculate percentage change
          let percentageChange = null;
          if (comparisonAOV !== 0) {
            percentageChange = ((aov - comparisonAOV) / comparisonAOV) * 100;
          } else if (comparisonAOV === 0 && aov > 0) {
            percentageChange = 100;
          } else {
            percentageChange = 0;
          }

          // Remove existing badge (including placeholder)
          // Re-check for badge since it might have been added after initial check
          const currentBadgeWrapper = parentContainer.length > 0 
            ? parentContainer.siblings(".row.hard-center").has(".aov-comparison-badge")
            : aovElement.siblings(".row.hard-center").has(".aov-comparison-badge");
          if (currentBadgeWrapper.length > 0) {
            currentBadgeWrapper.remove();
          } else {
            // Fallback: try finding badge without parent wrapper
            const fallbackBadge = parentContainer.length > 0 
              ? parentContainer.find(".aov-comparison-badge")
              : aovElement.siblings(".aov-comparison-badge");
            if (fallbackBadge.length > 0) {
              fallbackBadge.remove();
            }
          }

          if (percentageChange !== null && !isNaN(percentageChange)) {
            const roundedChange = Math.round(percentageChange);
            const badgeClass = roundedChange > 0
              ? "bg-green-100 text-green-800"
              : roundedChange < 0
              ? "bg-red-100 text-red-800"
              : "bg-gray-100 text-gray-800";
            const comparisonLabel = options.comparison_label || "vs last period";
            const hideComparisonLabel = options.hide_comparison_label === true;
            const badgeTitleAttr = hideComparisonLabel ? "" : ` title="${comparisonLabel}"`;
            const labelSpan = hideComparisonLabel
              ? ""
              : `<span class="ml-1 aov-comparison-label" style="display: none;">${comparisonLabel}</span>`;

            const arrowSvg = roundedChange > 0
              ? '<svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" style="transform: rotate(-45deg)"><path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" /></svg>'
              : roundedChange < 0
              ? '<svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" style="transform: rotate(45deg)"><path fill-rule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" /></svg>'
              : "";

            const badge = $(`
              <div class="row hard-center"${badgeTitleAttr}>
                <span class="inline-flex items-center px-2 py-1 rounded text-base font-medium aov-comparison-badge ${badgeClass}"${badgeTitleAttr}>
                  ${arrowSvg}
                  ${Math.abs(roundedChange)}%
                  ${labelSpan}
                </span>
              </div>
            `);

            badge
              .find(".aov-comparison-badge")
              .on("mouseenter", function () {
                $(this).find(".aov-comparison-label").css("display", "inline-block");
              })
              .on("mouseleave", function () {
                $(this).find(".aov-comparison-label").css("display", "none");
              });

            // Insert badge - append after parent container to place on new line
            if (options.badgeContainer) {
              $(options.badgeContainer).append(badge);
            } else {
              if (parentContainer.length > 0) {
                parentContainer.after(badge);
              } else {
                aovElement.after(badge);
              }
            }
          } else {
            // If no valid comparison, remove placeholder if it exists
            const currentBadgeWrapper = parentContainer.length > 0 
              ? parentContainer.siblings(".row.hard-center").has(".aov-comparison-badge")
              : aovElement.siblings(".row.hard-center").has(".aov-comparison-badge");
            if (currentBadgeWrapper.length > 0) {
              currentBadgeWrapper.remove();
            } else {
              // Fallback: try finding badge without parent wrapper
              const fallbackBadge = parentContainer.length > 0 
                ? parentContainer.find(".aov-comparison-badge")
                : aovElement.siblings(".aov-comparison-badge");
              if (fallbackBadge.length > 0) {
                fallbackBadge.remove();
              }
            }
          }
        } else {
          // Invalid comparison data, remove placeholder
          const currentBadgeWrapper = parentContainer.length > 0 
            ? parentContainer.siblings(".row.hard-center").has(".aov-comparison-badge")
            : aovElement.siblings(".row.hard-center").has(".aov-comparison-badge");
          if (currentBadgeWrapper.length > 0) {
            currentBadgeWrapper.remove();
          } else {
            // Fallback: try finding badge without parent wrapper
            const fallbackBadge = parentContainer.length > 0 
              ? parentContainer.find(".aov-comparison-badge")
              : aovElement.siblings(".aov-comparison-badge");
            if (fallbackBadge.length > 0) {
              fallbackBadge.remove();
            }
          }
        }
      } else if (!effectiveComparisonExpected || !hasComparisonPayload || checkCount >= maxChecks) {
        // No comparison expected, no comparison payload, or timeout reached, remove all badges and stop checking
        const currentBadgeWrapper = parentContainer.length > 0 
          ? parentContainer.siblings(".row.hard-center").has(".aov-comparison-badge")
          : aovElement.siblings(".row.hard-center").has(".aov-comparison-badge");
        if (currentBadgeWrapper.length > 0) {
          currentBadgeWrapper.remove();
        } else {
          // Fallback: try finding badge without parent wrapper
          const fallbackBadge = parentContainer.length > 0 
            ? parentContainer.find(".aov-comparison-badge")
            : aovElement.siblings(".aov-comparison-badge");
          if (fallbackBadge.length > 0) {
            fallbackBadge.remove();
          }
        }
        clearInterval(aov_check);
      }
      
      checkCount++;
    }
  }, 500);
};

export default updateAOV;
